import React from 'react'
import ProdWastageRow from './ProdWastageRow'
import withView from '../../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import { UiView, UiViewContent } from "../../../../../library/layout/Index";

const ProdWastage = (props) => {
    const { formObject, viewData } = props;

    return (
        <>
            <UiView>
                <UiViewContent>
                    <ul className="uiListTable uiSpacer20">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn30"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn90"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Unit" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Qty Issued" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Qty Wasted" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Qty Damaged" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Qty Lost" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="% Allow" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Qty Allow" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Qty Diff" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="% Loss" /></li>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="% Diff" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Wastage Value" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Deduction" /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Remark" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData.viewRows : {}).map((row, index) => (
                                <li><ProdWastageRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} index={index + 1} /></li>
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdWastage, "prodWaste", "");
